import { connect } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { useEffect, useRef } from "react";

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

import {
  NavSearch,
  SearchWrapper,
  DIV56
} from "./style"

import { actions } from "./store";

import Hot from "./hot";

const Header = ({
  focused,
  keyword,
  mouseIn,
  handleInputFocus,
  handleOnKeyUp,
  handleOnBlur,
  list,
}) => {

  const inputValue = useRef(null);

  useEffect(() => {
    if(keyword != undefined) {
      inputValue.current.value = keyword
    }
    
  }, [keyword]);

  return (
    <>
      <Navbar bg="dark" expand="lg" data-bs-theme="dark" fixed="top">
        <Container>
          <Navbar.Brand href="/">无尘阁</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          
          <SearchWrapper>
            <CSSTransition in={focused} timeout={200} classNames="slide">
              <NavSearch
                className={focused ? "focused" : ""}
                ref={inputValue}
                onFocus={() => handleInputFocus(list)}
                onKeyUp={(e) => handleOnKeyUp(e)}
                onBlur={() => handleOnBlur()}
              ></NavSearch>
            </CSSTransition>
            <i className={focused ? "focused iconfont zoom" : "iconfont zoom"}>
              &#xe614;
            </i>
            {focused || mouseIn ? <Hot /> : null}
          </SearchWrapper>
          
        </Container>
      </Navbar>
      <DIV56 />
    </>
  );
};

const mapState = (state) => {
  return {
    focused: state.getIn(["header", "focused"]),
    list: state.getIn(["header", "list"]),
    keyword: state.getIn(["header", "keyword"]),
    page: state.getIn(["header", "page"]),
    totalPage: state.getIn(["header", "totalPage"]),
    mouseIn: state.getIn(["header", "mouseIn"]),
    login: state.getIn(["home", "login"]),
  };
};

const mapDispatch = (dispatch) => {
  return {
    handleInputFocus(list) {
      list.size === 0 && dispatch(actions.getList());
      dispatch(actions.searchFocus());
    },
    handleOnBlur() {
      dispatch(actions.searchBlur());
    },
    handleOnKeyUp(e) {
      if(e.keyCode == 13) {
        dispatch(actions.setKeyword(e.target.value))
      }
    }
  };
};

export default connect(mapState, mapDispatch)(Header);
